export const TEXT = {
    VIEW_ALL: 'View All',
    VIEW_ALL_LOWERCASE: 'view all',
    IMAGES: 'images',
    VIDEOS: 'videos'
};

